/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：379
 */

"use strict"

var r
export { r as a };
(function (e) {
  e.BUTTON = "BUTTON"
  e.DEFAULT = "DEFAULT"
})(r || (r = {}))
export default r
